import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'


import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'


import { uniqueArray, isAllowedToViewComponent, romanize, formatcoin, getDivisa } from '../../utils/helpers';


import { showModalConfirmarAccion, getParameterByName, showModalSelector, selectFromSelector } from '../../actions/common'


import {
    seleccionarAprobacion,
    registrarResultadoAprobacion,
    updateInputs,
    crearAprobacionAdicionalBiene
} from '../../actions/solicitudbi'




class Aprobaciones extends Component {


    constructor(props) {
        super(props);
        this.state = {
            solicitarAprobacionAdicional: false,
            aprobadorAdicional: null,
            motivoAprobacionAdicional: ''
        };
    }


    componentWillMount() {
        this.props.getParameterByName('SMMLV')
        this.props.getParameterByName('MATRIZ_APROBACION')
        this.props.getParameterByName('APROBADORES_ADICIONALES')
    }


    handleOpenSelectorAprobador = () => {
        const fields = [
            { id: 1, caption: 'Nombre', value: 'fullname', width: '40%' },
            { id: 2, caption: 'Cargo', value: 'cargo', width: '40%' },
            { id: 3, caption: 'Miembro', value: 'esmiembrocomite', width: '20%' }
        ];
        this.props.showModalSelector(
            'Seleccione aprobador adicional',
            fields,
            '/usuarios/aprobadores-adicionales',
            (aprobador) => {
                this.setState({ aprobadorAdicional: aprobador });
            }
        );
    }    



    getTotal = (valor, iva, cantidad) => {

        if (!valor) return 0
        if (!cantidad) return 0        

        const total = valor*cantidad
        return iva ? total+((iva*total)/100) : total
    }



    getProveedores = () => {

        const cotizaciones = this.props.solicitudBI.get('cotizaciones')
        const proveedores = []

        cotizaciones && cotizaciones.map(c => {
            let index = -1
            proveedores.forEach((p,i) => {
                if (c.get('proveedor_id') == p.get('id')) index = i;                
            })
            if (c.get('proveedor_id') && index == -1) {
                proveedores.push(c.get('proveedore'))
            }
        })

        return proveedores.sort((a,b)=>(a.get('id')-b.get('id')))

    }



    getTotalCotizacion = () => {
        const total = this.props.solicitudBI.get('bienes').reduce((acum,bien) => {
            acum += bien.get('cotizaciones').filter(c => c.get('recomendado')).reduce((acum2, cotizacion)=> {
                acum2 += Number(cotizacion.get('cotizado_iva')) * Number(bien.get('cantidad_solicitada'))
                return acum2
            }, 0)
            return acum
        }, 0)
        return total 
    }



    getTotalCotizacionTrm = () => {
        const total = this.props.solicitudBI.get('bienes').reduce((acum,bien) => {
            acum += bien.get('cotizaciones').filter(c => c.get('recomendado')).reduce((acum2, cotizacion)=> {
                const trm = cotizacion.get('trm') ? cotizacion.get('trm') : 1
                const cotizado_iva = cotizacion.get('cotizado_iva') ? cotizacion.get('cotizado_iva') : 0
                const cantidad_solicitada = bien.get('cantidad_solicitada') ? bien.get('cantidad_solicitada') : 0
                acum2 += cotizado_iva * trm * cantidad_solicitada
                return acum2
            }, 0)
            return acum
        }, 0)
        return total 
    }    




    getTotalCotizacionProveedor = (proveedor_id) => {
        const total = this.props.solicitudBI.get('bienes').reduce((acum,bien) => {
            acum += bien.get('cotizaciones').reduce((acum2, cotizacion)=> {
                if (cotizacion.get('proveedor_id') == proveedor_id && cotizacion.get('recomendado')){
                    acum2 += Number(cotizacion.get('cotizado_iva')) * Number(bien.get('cantidad_solicitada'))
                }
                return acum2
            }, 0)
            return acum
        }, 0)
        return total 
    }




    getTotalAprobador = (aprobador_id) => {

        const total = this.props.solicitudBI.get('cotizaciones').reduce((acum1,item1) => {
            if (item1.get('recomendado')) {
                const idx = item1.get('aprobaciones').findIndex(x => x.get('aprobador_id') == aprobador_id)
                if (idx != -1) {
                    const bienId = item1.getIn(['bienes', 0, 'id'])
                    const bienIdx = this.props.solicitudBI.get('bienes').findIndex(b => b.get('id') == bienId)
                    if (bienIdx != -1) {
                        const cantidad = this.props.solicitudBI.getIn(['bienes', bienIdx, 'cantidad_solicitada'])
                        acum1 += Number(item1.get('cotizado_iva')) * Number(cantidad)
                    }
                }
            }
            return acum1
        }, 0)

        return total
    }





    approve = (aprobaciones, cencos, totalAprobador, divisa) => {
        this.props.showModalConfirmarAccion(true, 
            `Al hacer click en Ok, estará aprobando el cargue de ${ formatcoin( totalAprobador, divisa.simbolo) } 
            ${cencos.length > 1 ? 'entre los ' : 'al'} centro${cencos.length > 1 ? 's' : ''} de costo ${uniqueArray(cencos).join(', ') }
            ${this.props.solicitudBI.get('tipo') == 5 ? `y con la fecha de entrega ${moment(this.props.solicitudBI.get('fecha_requerido')).format('DD/MM/YYYY')} `: '' }`,
            () => { this.props.showModalConfirmarAccion(false); this.props.registrarResultadoAprobacion(aprobaciones, 2)}
        ) 
    }

    reject = (aprobaciones, cencos, totalAprobador, divisa) => {
        this.props.showModalConfirmarAccion(true, 
            `Al hacer click en Ok, estará rechazando el cargue de ${ formatcoin( totalAprobador, divisa.simbolo) } 
            ${cencos.length > 1 ? 'entre los ' : 'al'} centro${cencos.length > 1 ? 's' : ''} de costo ${uniqueArray(cencos).join(', ') }
            ${this.props.solicitudBI.get('tipo') == 5 ? `y con la fecha de entrega ${moment(this.props.solicitudBI.get('fecha_requerido')).format('DD/MM/YYYY')} `: '' }`,
            () => { this.props.showModalConfirmarAccion(false); this.props.registrarResultadoAprobacion(aprobaciones, 0)}
        ) 
    }

    getTipoCompra = (bien) => { 
        const tiene_proveedor = (bien.get('cotizaciones').filter(c => c.get('proveedor_id') != null).count() > 0)
        if (bien.get('compra_directa') && !tiene_proveedor) return 1
        if (!bien.get('compra_directa') && tiene_proveedor) return 2
        if (bien.get('compra_directa') && tiene_proveedor) return 3
        return 1  
    }


    changeValueCotizacion = (cotizacion_id, attr, value) => {

        const bienes = this.props.solicitudBI.get('bienes')
        const cotizaciones = this.props.solicitudBI.get('cotizaciones')

        const cotizacion = cotizaciones.filter(c => c.get('id') == cotizacion_id).first()
        const bien_id = cotizacion.getIn(['bienes', 0, 'id'])
        const bien_idx = bienes.findIndex(x => x.get('id') == bien_id)


        if (bien_idx >= 0) {


            if (attr == 'recomendado') {


                    bienes.getIn([bien_idx, 'cotizaciones']).valueSeq().forEach(cot => {
                        const idx = bienes.getIn([bien_idx, 'cotizaciones']).findIndex(x => x.get('id') == cot.get('id'))
                        this.props.updateInputs(`solicitud.bienes.${bien_idx}.cotizaciones.${idx}.recomendado`, false)
                    })
    
                    cotizaciones.valueSeq().forEach((cot,idx) => {
                        if (cot.getIn(['bienes',0,'id']) == bien_id) {
                            this.props.updateInputs(`solicitud.cotizaciones.${idx}.recomendado`, false)
                        }
                    })

            }
            

            const cotizacion_idx = bienes.getIn([bien_idx, 'cotizaciones']).findIndex(x => x.get('id') == cotizacion_id)

            if (cotizacion_idx >= 0) {                
                this.props.updateInputs(`solicitud.bienes.${bien_idx}.cotizaciones.${cotizacion_idx}.${attr}`, value, cotizacion_id)
            }


        }

    } 

    actualizarrecomendado = (indice, valor) => {
        this.props.updateInputs(`solicitud.bienes.${indice}.cantidad_solicitada`, valor)
        const idbien = this.props.solicitudBI.getIn(['bienes', indice, 'id'])
        this.props.updateInputs(`solicitud.bienes.${indice}.cantidad_solicitada`, valor, idbien)
        const cotizaciones = this.props.solicitudBI.get('cotizaciones')
        const dato = cotizaciones.filter(c=> c.getIn(['bienes', indice, 'pivot', 'bienes_detalle_id']) == idbien )
        cotizaciones.filter(c=> c.getIn(['bienes', 0, 'pivot', 'bienes_detalle_id']) == idbien ).map((c) => {
            const idc = c.get('id') 
            if (valor == 0){
                this.changeValueCotizacion(idc, 'recomendado', false)
            }
        });
    }


    handleEnviarSolicitudAdicional = () => {
        const { aprobadorAdicional, motivoAprobacionAdicional } = this.state;
        if (!aprobadorAdicional || !motivoAprobacionAdicional.trim()) {
            return;
        }

        this.props.crearAprobacionAdicionalBiene(aprobadorAdicional, motivoAprobacionAdicional);
   
        this.setState({
            solicitarAprobacionAdicional: false,
            aprobadorAdicional: null,
            motivoAprobacionAdicional: ''
        });
    }


    tipo_corte = () => {

        const { smmlv, matriz_aprobacion } = this.props

        let tipoAprobacion = 1

        const totalSMMLV = (smmlv && (this.getTotalCotizacionTrm() / parseFloat(smmlv.first().get('SMMLV')))) || 0;

        const match = matriz_aprobacion && matriz_aprobacion.find(item =>
            parseFloat(item.get('DESDE_SMMLV')) <= totalSMMLV && totalSMMLV < parseFloat(item.get('HASTA_SMMLV'))
        );

        if (match) {
            tipoAprobacion = match && parseInt(match.get('TIPO_APROBACION')) || 1;
        }

        return tipoAprobacion;
        
    }

    info_aprobador_adicional = (aprobador) => {
        const { aprobadores_adicionales } = this.props;
        if (!aprobador) return null;
        if (!aprobadores_adicionales) return null;
        const aprobadorInfo = aprobadores_adicionales.find(a => a.get('USUARIO') === aprobador.get('username'));
        if (!aprobadorInfo) return null;
        return {
            cargo: aprobadorInfo.get('CARGO') || 'Sin cargo',
            esmiembrocomite: aprobadorInfo.get('MIEMBRO_COMITE') === 'SI'
        };
    }

    render() {
        
        const { id, solicitudBI, enums, aprobadores, btnAproveDisabled, divisas } = this.props  

        let botonAprove = true;
        if(this.props.btnSaveDisabled){
            botonAprove = false;
        }
        const moneda = solicitudBI.get('cotizaciones') ? solicitudBI.get('cotizaciones').first().get('moneda') : 'COP'        
        const divisa = getDivisa(divisas, moneda)

        const proveedores = this.getProveedores()

        const es_aprobador = isAllowedToViewComponent('aprobador', aprobadores)
        const readOnly = solicitudBI.get('estado') == 0 || solicitudBI.get('estado') > 3 || !es_aprobador



        if (!id) return null


		return (<Fragment>
            <div className="row">
                <div className="col-md-12" style={{overflow: 'auto', whiteSpace: 'nowrap', paddingBottom: '25px'}}>
                    <table className="table table-condensed table-bordered table-striped" id="comparativo-cotizaciones">

                        <thead>
                            <tr>
                                <td colSpan={4} style={{borderTop: '1px solid #FFF', borderLeft: '1px solid #FFF'}}></td>
                                { 
                                    proveedores.map((p,i) => {
                                        return <th key={`phead[${i}]`}>{p.get('nombre')}</th>                                                        
                                    })
                                }
                                <th>COMPRA DIRECTA</th>
                            </tr>
                            <tr>
                                <th>Descripción inicial</th>   
                                <th>Observación</th> 
                                <th>U.M.</th> 
                                <th>Cantidad</th>
                                {
                                    proveedores.map((p,i) => {
                                        return <Fragment key={`pcol[${i}]`}>
                                            <th></th>
                                        </Fragment>                                                                                           
                                    })
                                }
                                <th></th>
                            </tr>
                        </thead>  
                        <tbody>
                        {
                            solicitudBI.get('bienes').map((bien, bienIndex) => {

                                const cantidad = bien.get('cantidad_solicitada')
                                const tipo_compra = this.getTipoCompra(bien)

                                return <tr key={`itm[${bienIndex}]`}>   


                                    <td>
                                        <input 
                                            className="form-control input-sm" 
                                            type="text" 
                                            style={{ width: '200px'}}
                                            value={bien.get('descripcion') || ''} 
                                            onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${bienIndex}.descripcion`, e.target.value, bien.get('id')) }  
                                            disabled={readOnly}
                                        />
                                    </td>


                                    <td>
                                        <div className="form-group" style={{ width: '200px'}}>
                                            <textarea 
                                                className="form-control input-sm" 
                                                rows={3} 
                                                value={bien.get('observaciones')||''}
                                                onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${bienIndex}.observaciones`, e.target.value, bien.get('id')) }
                                                disabled={readOnly}
                                            />
                                        </div>
                                    </td>


                                    <td>{bien.get('unidad')}</td>
                                    <td>
                                        <input
                                            style={{ width: '100px'}} 
                                            type="number"  
                                            className="form-control input-sm"                                                  
                                            value={bien.get('cantidad_solicitada')}
                                            onChange={ (e) => this.actualizarrecomendado(bienIndex, e.target.value) }                                            
                                            disabled = {readOnly}
                                        />
                                    </td>
                                    {
                                        proveedores.map(p => {

                                            const cotizaciones_proveedor = bien.get('cotizaciones').filter(cotizaciones => cotizaciones.getIn(['pivot', 'bienes_detalle_id']) == bien.get('id') && cotizaciones.get('proveedor_id') == p.get('id'))

                                            return(
                                                <td key={`tdprov[${p.get('id')}][${bien.get('id')}]`}>

                                                    <table className="table table-condensed table-bordered table-striped">
                                                        <thead> 
                                                            <tr>
                                                                <th></th>                                         
                                                                <th>Marca</th>
                                                                <th>Vlr. Unitario</th>
                                                                <th>IVA</th>
                                                                <th>Vlr. con IVA</th>
                                                                <th>T. Entrega</th>
                                                            </tr>  
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                cotizaciones_proveedor.map((cp, cpi) => {
                                                                    
                                                                    const valor = cp.get('cotizado') ? cp.get('cotizado') : 0
                                                                    const iva = cp.get('iva') ? cp.get('iva') : 0

                                                                    return <tr key={`cp[${bien.get('id')}][${cp.get('id')}][${cp.get('proveedor_id')}]`}>
                                                                        <td><input type="checkbox" checked={cp.get('recomendado')} onChange={(e) => this.changeValueCotizacion(cp.get('id'), 'recomendado', e.target.checked)} disabled={bien.get('cantidad_solicitada')==0||readOnly} /></td>
                                                                        <td><div style={{ width: '150px'}}>{ cp.get('marca')}</div></td>                                                                
                                                                        <td><div style={{ width: '150px', textAlign: 'right'}}>{ valor}</div></td>
                                                                        <td><div style={{ width: '100px', textAlign: 'right'}}>{ `${ iva }%` }</div></td>
                                                                        <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( (this.getTotal(valor,iva,cantidad)), divisa.simbolo ) }</div></td>                                                                
                                                                        <td><div style={{ width: '100px', textAlign: 'right'}}>{ cp.get('tiempo_entrega') }</div></td>                                                                
                                                                    </tr>

                                                                })
                                                            }
                                                        </tbody>
                                                    </table>

                                                </td>  
                                                )
                                            })
                                        }

                                        <td>
                                        {
                                            (tipo_compra == 1) && (
                                                <table className="table table-condensed table-bordered table-striped">
                                                    <thead> 
                                                        <tr>  
                                                            <th></th>  
                                                            <th>Proveedor</th>                                    
                                                            <th>Marca</th>
                                                            <th>Vlr. Unitario</th>
                                                            <th>IVA</th>
                                                            <th>Vlr. con IVA</th>
                                                            <th>T. Entrega</th>
                                                        </tr>  
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            bien.get('cotizaciones').map((cotizacion, cotizacionIndex) => {

                                                                const valor = cotizacion.get('cotizado') ? cotizacion.get('cotizado') : 0
                                                                const iva = cotizacion.get('iva') ? cotizacion.get('iva') : 0

                                                                return <tr key={`tr1[${bienIndex}][${cotizacionIndex}]`}>
                                                                    <td><input type="checkbox" checked={cotizacion.get('recomendado')} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'recomendado', e.target.checked)} disabled={cantidad==0||readOnly} /></td>
                                                                    <td><div style={{ width: '200px'}}>{ cotizacion.get('proveedor_nombre_cp') }</div></td>
                                                                    <td><div style={{ width: '150px'}}>{cotizacion.get('marca')} </div></td>
                                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( valor, divisa.simbolo ) }</div></td>
                                                                    <td><div style={{ width: '100px', textAlign: 'right'}}>{ `${iva}%` }</div></td>
                                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( (this.getTotal(valor,iva,cantidad)), divisa.simbolo ) }</div></td>
                                                                    <td><div style={{ width: '100px', textAlign: 'right'}}>{cotizacion.get('tiempo_entrega')}</div></td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }


                                        {
                                            (tipo_compra == 3 && bien.get('cotizaciones').filter(c => !c.get('proveedor_id')).count() > 0) && (
                                                <table className="table table-condensed table-bordered table-striped">
                                                    <thead> 
                                                        <tr> 
                                                            <th></th>   
                                                            <th>Proveedor</th>                                    
                                                            <th>Marca</th>
                                                            <th>Vlr. Unitario</th>
                                                            <th>IVA</th>
                                                            <th>Vlr. con IVA</th>
                                                            <th>T. Entrega</th>
                                                        </tr>  
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            bien.get('cotizaciones').filter(c => !c.get('proveedor_id')).map((cotizacion, cotizacionIndex) => {

                                                                const valor = cotizacion.get('cotizado') ? cotizacion.get('cotizado') : 0
                                                                const iva = cotizacion.get('iva') ? cotizacion.get('iva') : 0 

                                                                return <tr key={`tr1[${bienIndex}][${cotizacionIndex}]`}>
                                                                    <td><input type="checkbox" checked={cotizacion.get('recomendado')} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'recomendado', e.target.checked)} disabled={valor==0||readOnly} /></td>
                                                                    <td><div style={{ width: '200px'}}>{ cotizacion.get('proveedor_nombre_cp') }</div></td>
                                                                    <td><div style={{ width: '150px'}}>{cotizacion.get('marca')} </div></td>
                                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( valor, divisa.simbolo ) }</div></td>
                                                                    <td><div style={{ width: '100px', textAlign: 'right'}}>{ `${iva}%` }</div></td>
                                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( (this.getTotal(valor,iva,cantidad)), divisa.simbolo ) }</div></td>
                                                                    <td><div style={{ width: '100px', textAlign: 'right'}}>{cotizacion.get('tiempo_entrega')}</div></td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }
                                        </td>
                                    </tr>
                                })
                            }

                            <tr style={{backgroundColor: '#eee'}}>
                                <th colSpan={4} style={{ textAlign: 'right'}}><strong>Total Seleccionado por Proveedor</strong></th>
                                {
                                    proveedores.map((p,i) => {
                                        return <Fragment key={`fcol[${i}]`}>
                                            <th><strong>{ formatcoin( (this.getTotalCotizacionProveedor(p.get('id'))), divisa.simbolo ) }</strong></th>                                            
                                        </Fragment>
                                    })
                                }
                                <th></th>
                            </tr>
                            
                            
                        </tbody>                  
                    
                    </table>                
                </div>
            </div>

            <div className="separator" />
            <div className="separator" />


            {this.tipo_corte() === 1 && solicitudBI.get('estado') === 3 && (
                <BoxSection title="Aprobación adicional">
                    <div className="row">
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={this.state.solicitarAprobacionAdicional}
                                        onChange={e => this.setState({ solicitarAprobacionAdicional: e.target.checked })}
                                    />
                                    <span style={{marginLeft: '7px'}}>Solicitar aprobación adicional</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-3">
                            {this.state.solicitarAprobacionAdicional && (
                                <div className="form-group">
                                    <label className="control-label">Seleccione aprobador adicional</label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <SelectorInput 
                                            value={this.state.aprobadorAdicional ? this.state.aprobadorAdicional.fullname : ''} 
                                            onClick={this.handleOpenSelectorAprobador}
                                            onReset={ () => this.setState({ aprobadorAdicional: null }) }
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                            <Fragment>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Cargo del aprobador:</label>
                                        <div className="form-control input-sm" style={{ background: '#f9f9f9', paddingTop: '5px' }}>
                                            {this.state.aprobadorAdicional.cargo || 'Sin cargo'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                                    {this.state.aprobadorAdicional.esmiembrocomite === 'SI' && (
                                        <span className="label label-success" style={{ fontSize: 13 }}>
                                            Integrantes del Comité de Rectoría
                                        </span>
                                    )}
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div>
                        {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Motivo de la solicitud adicional</label>
                                        <textarea 
                                            rows={3} 
                                            className="form-control input-sm" 
                                            value={this.state.motivoAprobacionAdicional}
                                            onChange={e => this.setState({ motivoAprobacionAdicional: e.target.value })} 
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                        <div className="row">
                            <div className="col-md-12" style={{ textAlign: 'right', paddingTop: '10px', paddingBottom: '10px' }}>
                                <button
                                    className="btn btn-primary btn-sm"
                                    disabled={
                                        !this.state.motivoAprobacionAdicional.trim() ||
                                        !this.state.aprobadorAdicional
                                    }
                                    onClick={this.handleEnviarSolicitudAdicional}
                                >
                                    Enviar solicitud adicional
                                </button>
                            </div>
                        </div>
                    )}
                </BoxSection>
            )}

            <div className="separator" />

            {
                aprobadores.map((aprobador, aprobadoridx) => {
                    const nombre_aprobador = aprobador.get('fullname')
                    
                    const aprobacion = aprobador.get('aprobaciones').filter(x => x.get('estado') == 2).count() > 0 ? aprobador.get('aprobaciones').filter(x => x.get('estado') == 2).first() : aprobador.get('aprobaciones').first()


                    const estado = aprobacion.get('estado')
                    const tipo = aprobacion.get('tipo')
                    const fecha = aprobacion.get('fecha')
                    const observaciones = aprobacion.get('observaciones');
                    const aprobador_id = aprobador.get('id')
                    const cencos = []
                    const nombre_aprobador_original = aprobacion.getIn(['aprobador_su','fullname']);

                    let totalAprobador = 0

                    const info_aprobador_adicional = this.info_aprobador_adicional(aprobador);


                    return [

                        (aprobadoridx > 0) ? <div key={ `sep1[${aprobadoridx}]` } className="separator" /> : null,


                        <BoxSection key={ `bs1[${aprobador.get('id')}]` } title={
                            tipo === 3 ? (
                                <span>
                                    {estado === 2 ? <FontAwesome name="check" style={{ color: 'green' }} /> : estado === 0 ? <FontAwesome name="times" style={{ color: 'red' }} /> : ''}
                                    Solicitud de aprobación adicional a <strong>{nombre_aprobador}</strong>
                                </span>
                            ) : (
                                <span>
                                    {estado === 2 ? <FontAwesome name="check" style={{ color: 'green' }} /> : estado === 0 ? <FontAwesome name="times" style={{ color: 'red' }} /> : ''}
                                    Solicitud de aprobación nivel {romanize(tipo)} a <strong>{nombre_aprobador}</strong>
                                </span>
                            )
                        }>

                            {info_aprobador_adicional && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <span style={{ fontWeight: 500 }}>
                                            Cargo: {info_aprobador_adicional.cargo || 'Sin cargo'}
                                        </span>
                                        {info_aprobador_adicional.esmiembrocomite ? (
                                            <span className="label label-success" style={{ marginLeft: 10 }}>
                                                Integrantes del Comité de Rectoría
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                            )}


                            <div className="row">
                                <div className="col-md-12">
                                    <h4>Solicitud de aprobación: { enums.aprobaciones.estados[estado] }{ estado === 1 ? '' : <span> &bull; { moment(fecha).format('YYYY-MM-DD HH:mm') }</span> }</h4>
                                </div>
                            </div>

                            {                   
                                nombre_aprobador_original && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>Esta solicitud fue aprobada por <b>{ nombre_aprobador_original }</b></span>                                                
                                        </div>
                                    </div>                                        
                                )
                            }


                            <div className="row">
                                <div className="col-md-12">
                                    <span>Solicitada por <b>{ solicitudBI.getIn(['solicitante', 'fullname']) }</b></span> &bull; <span><a href={ `mailto:${solicitudBI.getIn(['solicitante', 'email'])}` }>{ solicitudBI.getIn(['solicitante', 'email']) }</a></span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <span>Fecha de entrega: </span><b>{moment(solicitudBI.get('fecha_requerido')).format('DD/MM/YYYY')}</b>
                                </div>
                            </div> 

                            <div key={ `sep2[${aprobadoridx}]` } className="separator" />

                            <div className="row">
                                <div className="col-md-12">
                                    <b>Detalle:</b>
                                </div>
                            </div>

                            <div key={ `sep3[${aprobadoridx}]` } className="separator" />

                            <div className="row">
                                <div className="col-md-12">
                                    <table key={`tbl[${aprobadoridx}]`} className="table table-bordered table-condensed table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '50%' }}></th>
                                                <th style={{ width: '50%' }}>Distribución</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>

                                                <td style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center', verticalAlign: 'middle'}}>{ formatcoin( (this.getTotalCotizacion()), divisa.simbolo ) }</td>

                                                <td>
                                                    {
                                                        aprobacion.getIn(['cotizacione', 'bienes']).map((b, bidx) => {
                                                            return (
                                                                <table key={`tbl[${aprobadoridx}][${bidx}]`} className="table table-bordered table-condensed">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Cenco</th>
                                                                            <th>Porcentaje</th>
                                                                            <th>Valor</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            b.get('cencos').map((c) => {

                                                                                if ((tipo < 2) && c.get('responsable_id') != aprobador_id && c.getIn(['pivot', 'aprobador_id']) != aprobador_id) return null
                                                                                
                                                                                cencos.push(c.get('codigo'))
                                                                                totalAprobador += (c.getIn(['pivot', 'porcentaje']) / 100) * this.getTotalCotizacion() 

                                                                                return (
                                                                                    <tr key={ `tr2[${aprobador.get('id')}][${b.get('id')}][${c.get('id')}]` }>
                                                                                        <td><span title={ `${c.get('descripcion')}` }>{ c.get('codigo') }</span></td>
                                                                                        <td style={{ textAlign: 'right' }}>{ numeral(c.getIn(['pivot', 'porcentaje']) / 100).format('0.0%') }</td>
                                                                                        <td style={{ textAlign: 'right' }}>{ formatcoin( ((c.getIn(['pivot', 'porcentaje']) / 100) * this.getTotalCotizacion()), divisa.simbolo ) }</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            )
                                                        })
                                                    }
                                                </td>

                                            </tr>

                                        </tbody>                                    
                                    </table>
                                </div>                            
                            </div>

                            {
                                (estado !== 1 &&
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="control-label">Observaciones</label>
                                                <div className="form-control input-sm" style={{ height: '60px', overflowX: 'hidden' }}>
                                                    { observaciones || '' }
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                )
                            }


                            {
                                (isAllowedToViewComponent('aprobacion', aprobador.get('aprobaciones').first()) && 
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="control-label">Observaciones</label>
                                                    <textarea rows={6} className="form-control input-sm" value={ observaciones || '' } onChange={ (e) => this.props.updateInputs(`aprobadores.${aprobadoridx}.aprobaciones.0.observaciones`, e.target.value) } disabled={tipo===3} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div style={{ textAlign: 'right', padding: '10px 0' }}>
                                                    <span>
                                                        <button 
                                                        className="btn btn-primary btn-sm btn-squared" 
                                                        onClick={ e => this.approve(aprobador.get('aprobaciones'), cencos, totalAprobador, divisa) } disabled={ botonAprove }>Aprobar</button>

                                                    </span>
                                                    <span style={{ marginLeft: '10px' }}>
                                                        <button className="btn btn-default btn-sm btn-squared" onClick={ e => this.reject(aprobador.get('aprobaciones'), cencos, totalAprobador, divisa) } disabled={ btnAproveDisabled }>Rechazar</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }                        
                        
                        </BoxSection>


                    ]
                })
            } 

            <ModalConfirmarAccion />
            <ModalSelectorFromList />

        </Fragment>)
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudBI.get('id'),
        solicitudBI: state.solicitudBI.get('solicitud'),
        aprobadores: state.solicitudBI.get('aprobadores'),
        enums: state.common.get('enums').toJS(),
        user: state.common.get('user'),
        btnAproveDisabled: state.solicitudBI.get('btnAproveDisabled'),
        divisas: state.common.getIn(['parametros', 'DIVISAS']),
        btnSaveDisabled: state.solicitudBI.get('btnSaveDisabled'),
        smmlv: state.common.getIn(['parametros', 'SMMLV']),
        matriz_aprobacion: state.common.getIn(['parametros', 'MATRIZ_APROBACION']),
        aprobadores_adicionales: state.common.getIn(['parametros', 'APROBADORES_ADICIONALES']),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        seleccionarAprobacion: (bienid, aprobadorid, aprobacionid) => dispatch(seleccionarAprobacion(bienid, aprobadorid, aprobacionid)),
        registrarResultadoAprobacion: (aprobaciones, result, bienes) => dispatch(registrarResultadoAprobacion(aprobaciones, result, bienes)),
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        crearAprobacionAdicionalBiene: (aprobadorAdicional, motivoAprobacionAdicional) => dispatch(crearAprobacionAdicionalBiene(aprobadorAdicional, motivoAprobacionAdicional)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Aprobaciones)





// WEBPACK FOOTER //
// ./src/components/SolicitudBI/Aprobaciones.jsx